"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const IndexWrapper = (props) => {
    const { children, index } = props;
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", index] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: `pages.${index}.title` }), children] }));
};
exports.IndexWrapper = IndexWrapper;
//# sourceMappingURL=index-wrapper.js.map